export default __webpack_public_path__ + "static/media/black_king.70cd75c8.png";